import { ENV, IS_FULL_URL } from 'common/constants';
import { isBrowser } from 'common/constants/config';
import { isObject } from 'common/utils';
import { getDomainInfos } from 'portal-common/helpers/domainUtils';

import { DOMAIN, FETCH_PREFIX_MAP } from '../constants';
import store from '../store';
import logger from './logger';

export const pathBase = (action) => {
  let path = '';
  let prePath = '';
  if (isObject(action)) {
    path = action?.path || '';
    prePath = action?.prePath || '';
  } else {
    path = action;
    prePath = action;
  }
  let reqPath = '';
  if (prePath) {
    reqPath = store.getPreview() ? prePath : path;
  } else {
    reqPath = path;
  }
  return reqPath;
};

export const getFrontApiBase = (req) => {
  let baseUrl;
  const domains = getDomainInfos();
  // 服务端环境时，从请求头获取当前域名
  if (!isBrowser && req) {
    const host = req.headers?.['x-forwarded-host'] || req.headers?.host || 'www.tencentcloud.com';
    return `https://${host}`;
  }
  if (domains?.QCMAIN_HOST && isBrowser) {
    // 1. 非流水线(即本地调试) 且 浏览器环境 ---> //intl.cloud.tencent.com (TODO: 直接相对路径即可)
    // 如果是服务端，随便怎么调用都可以？那让多域名只针对浏览器端，否则本地调试会调到测试环境
    baseUrl = `${isBrowser ? '' : 'https:'}//${domains.QCMAIN_HOST}`;
  } else if (process.env.ZONE_ENV) {
    // 2. 流水线 且 buildTime ---> 各流水线环境配置的baseUrl
    if (process.env.npm_lifecycle_event === ENV.BUILD) {
      baseUrl = DOMAIN[process.env.ZONE_ENV];
    }
  } else {
    // 3. 非流水线(即本地调试) 且 服务端环境 ---> baseUrl=http://127.0.0.1:3000
    if (!isBrowser) {
      baseUrl = DOMAIN[ENV.DEVELOPMENT];
    }
  }
  logger.info('getFrontApiBase', {
    baseUrl,
    ZONE_ENV: process.env.ZONE_ENV,
    npm_lifecycle_event: process.env.npm_lifecycle_event,
    domains,
    isBrowser,
  });
  return baseUrl || DOMAIN[ENV.PRODUCTION]; // 4. 兜底 ---> baseUrl=https://www.tencentcloud.com
};

export const getFrontApiPath = (action, fetchType) => {
  if (!isObject(action) && action.includes(IS_FULL_URL)) {
    return action;
  }
  const reqPath = pathBase(action);
  const fullPath = `${getFrontApiBase()}${FETCH_PREFIX_MAP[fetchType] || ''}${reqPath}`;
  if (!fullPath) {
    logger.warn('请求路径为空，请核对请求URL');
  }
  return fullPath;
};
